/** @jsx jsx */

import React, {
  Fragment as _,
  memo,
  useMemo,
  useCallback,
  useContext,
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
} from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { useSelector, connect } from 'react-redux';
import EditMarker from 'components/UI/EditMarker';
import placeholder from 'assets/addImg@3x.svg';
import { colors } from 'styles/variables';
import getBlockById from 'services/apiHelpers/getBlockById';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { EditWrapper0, EditWrapper1 } from './EditWrappers';
import ReactPlayer from 'react-player';
import VideoIcon from 'assets/Video.svg';
import useIntersectionObserver from 'hooks/useIntersectionObserver';
import { interactionContext } from 'components/lib/TextAndImage/interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
import onFullScreen from 'services/onFullScreen';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import embedIcon from 'assets/Embed.svg';
import EmbedPlaceholder from 'assets/EmbedPlaceholder.svg';

const { lPink, lGrey0, lGrey2 } = colors;

const frameSelected = keyframes`
  from {
    width: 50%;
    height: 50%;
  }
  to {
    width: 75%;
    height: 75%;
  }
`;

const minHeight = '50vh';
const getMinHeight = fullWindowHeight => {
  return fullWindowHeight ? 'calc(100vh - 250px)' : minHeight;
};

// ${loaded && `min-height: ${getMinHeight(fullWindowHeight)};`}

const IFrame = ({ src, fullWindowHeight }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <_>
      <iframe
        src={src || 'https://chameleoncreator.com/'}
        css={css`
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          height: 100%;

          border: none;

          ${!loaded &&
            `
            width: 0;
            height: 0;
          `}
        `}
        onLoad={(e: any) => {
          const iF = e.currentTarget;
          iF.style.minHeight = '50vh';
          setTimeout(() => {
            iF.style.minHeight = getMinHeight(fullWindowHeight);
          }, 1000 / 60);
          //
          setLoaded(true);
        }}
      ></iframe>
      {!loaded && (
        <div
          css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            min-height: ${getMinHeight(fullWindowHeight)};
          `}
        >
          <LoadingSpinner />
        </div>
      )}
    </_>
  );
};

const Embed = props => {
  const { id, src, fullWindowHeight = false, mediaParentId = null } = props;

  const focusedNodeId = useSelector((state: any) => state.focusedNodeId);
  const selected = id === focusedNodeId;

  return (
    <div
      css={css`
        position: relative;
        width: 100%;
        height: 100%;
        min-height: ${getMinHeight(fullWindowHeight)};
        // padding: 5px;
        border: 1px solid ${lGrey2};
        box-shadow: 5px 10px 20px 10px rgba(0, 0, 0, 0.05);

        ${!src &&
          `iframe {
            // pointer-events: none;
        }`}
      `}
    >
      {window.dev() ? (
        <EditWrapper1 id={id} mediaParentId={mediaParentId} selected={selected}>
          <IFrame src={src} fullWindowHeight={fullWindowHeight} />
        </EditWrapper1>
      ) : (
        <IFrame src={src} fullWindowHeight={fullWindowHeight} />
      )}
    </div>
  );
};

export default Embed;
